module.exports = __webpack_public_path__ + "static/img/10040.f6c6aa97.png";